import React from "react";
import HeaderOne from "../components/HeaderOne";
import { Helmet } from "react-helmet-async";
import FooterAreaOne from "../components/FooterAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import AlquilerServicesData from "../components/AlquilerServicesData";

const AlquilerServicePage = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      {/* Header one */}
      <HeaderOne />

      <Helmet>
        <title>Alquiler de Coches Sevilla | Vehículo de Sustitución | Leal</title>
        <meta name="description" content="Alquiler de coches en Sevilla y vehículos de sustitución durante reparaciones. Seat Ateca y Skoda Fabia 2020. Vehículos mantenidos profesionalmente. Gratis con seguro a todo riesgo." />
        <meta name="keywords" content="alquiler coches Sevilla, vehículo sustitución taller, coche cortesía Sevilla, alquiler coche Mairena, Seat Ateca alquiler, Skoda Fabia alquiler, vehículo de cortesía gratis" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Alquiler de Coches | Leal Taller Sevilla" />
        <meta property="og:description" content="Alquiler de coches en Sevilla. Seat Ateca y Skoda Fabia 2020. Vehículos mantenidos profesionalmente por nuestro taller." />
        <meta property="og:url" content="https://www.lealchapaypintura.com/alquiler" />
        <meta property="og:image" content="https://d147al5y0i1rb.cloudfront.net/uploads/car_picture/image/1501298/car_1757104926.jpeg" />
        <meta property="og:locale" content="es_ES" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Alquiler de Coches | Leal Taller Sevilla" />
        <meta name="twitter:description" content="Alquiler de coches en Sevilla. Seat Ateca y Skoda Fabia 2020 disponibles en Amovens." />
        <meta name="twitter:image" content="https://d147al5y0i1rb.cloudfront.net/uploads/car_picture/image/1501298/car_1757104926.jpeg" />
        <link rel="canonical" href="https://www.lealchapaypintura.com/alquiler" />

        {/* Service Schema for Car Rental */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Alquiler de Vehículos",
            "provider": {
              "@type": "AutoRepair",
              "name": "Leal Chapa y Pintura",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "C. Congreso, 57, Pol. P.I.S.A",
                "addressLocality": "Mairena del Aljarafe",
                "addressRegion": "Sevilla",
                "postalCode": "41927",
                "addressCountry": "ES"
              }
            },
            "areaServed": {
              "@type": "City",
              "name": "Sevilla"
            },
            "description": "Alquiler de vehículos Seat Ateca y Skoda Fabia 2020 en Sevilla a través de Amovens. Vehículos perfectamente mantenidos por profesionales."
          })}
        </script>
      </Helmet>

      {/* Breadcrumb */}
      <Breadcrumb
        title="Alquiler de Vehículos"
        parents={[{ label: "Servicios", path: "/#servicios" }]}
      />

      {/* Service Area One */}
      <AlquilerServicesData title={"Alquiler de Vehículos"} />

      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default AlquilerServicePage;
